import * as styles from '../NewbuildingCarousel.css';

/** @description Очищает значения стиля для курсора
 * @param ref {React.RefObject<HTMLDivElement>} ссылка на элемент
 * @return {void}
 */
export var cleanCursorStyles = function cleanCursorStyles(ref) {
  document.body.classList.add(styles['default-cursor']);

  /* istanbul ignore next */
  if (ref.current) {
    ref.current.classList.add(styles['default-cursor']);
  }
};